"use client";
import dynamic from "next/dynamic";

const FormDynamicWrapper = dynamic(() => import("./Form"), {
  ssr: true,
});

export default FormDynamicWrapper;
